export default {
  settings: {
    mimeType: 'application/ld+json',
    corsEnabled: false
  },
  environments: {
    staging: 'https://ugr.staging-api.immediate.co.uk',
    preproduction: 'https://ugr.preproduction-api.immediate.co.uk',
    production: 'https://ugr.api.immediate.co.uk'
  },
  endpoints: {
    recipes: {
      endpoint: '/v1/recipes'
    }
  }
};